var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderBuilder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 111,
    viewBox: "0 0 108 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 107.48,
    height: 110.06,
    rx: 20,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7383 62L44.2383 53L67.7383 37L71.0716 42V47H66.0716V52H61.0716V57H56.0716V62M50.5716 64.8333L49.7383 69.5L47.0716 71.5C45.5716 72.5 43.5716 72.1667 42.4049 70.6667L36.5716 62.5C35.5716 61 35.9049 59 37.4049 57.8333L42.9049 54L50.5716 64.8333M42.0716 58.6667L39.4049 60.5L45.2383 68.6667L47.9049 66.6667L42.0716 58.6667Z",
    fill: "#666666"
  })));
}
export default SvgPlaceholderBuilder;